import { TextFieldProps as MuiTextFieldProps, TextField as MuiTextField } from '@mui/material';
import React, { useMemo } from 'react';

import { RowFieldBase } from '../row-field-base';

export type TextFieldProps = MuiTextFieldProps & {
  readOnly?: boolean;
  disableBottomBorder?: boolean;
  isRow?: boolean;
  asterisk?: boolean;
};

const TextField: React.FC<TextFieldProps> = (props: TextFieldProps) => {
  const { id, label, fullWidth, readOnly, InputProps, SelectProps, disableBottomBorder, isRow, asterisk, ...rest } =
    props;

  const labelId = `${id}-label`;

  const inputProps = useMemo(
    () => (readOnly === undefined ? InputProps : { ...InputProps, readOnly }),
    [InputProps, readOnly],
  );

  const selectProps: typeof SelectProps = useMemo(
    () => ({
      ...SelectProps,
      SelectDisplayProps: {
        ...SelectProps?.SelectDisplayProps,
        'aria-labelledby': labelId,
        'aria-readonly': readOnly,
      },
    }),
    [SelectProps, labelId, readOnly],
  );

  if (isRow) {
    return (
      <RowFieldBase
        id={id}
        labelId={labelId}
        label={label}
        isHeading={false}
        disableBottomBorder={disableBottomBorder}
        asterisk={asterisk}
      >
        <MuiTextField
          id={id}
          InputProps={inputProps}
          SelectProps={selectProps}
          size="small"
          fullWidth={fullWidth ?? true}
          margin="none"
          {...rest}
        />
      </RowFieldBase>
    );
  }

  return (
    <MuiTextField
      label={label}
      id={id}
      InputProps={inputProps}
      SelectProps={selectProps}
      fullWidth={fullWidth ?? true}
      {...rest}
    />
  );
};

export { TextField };
